// CDN (Multi-CDN) self-serve activation gating — mirrors waap-service.ts.
//
// A first-time CDN activation defaults to the vEdge orchestrator, whose animal
// codename is `raven` (the consolidation destination for the Multi-CDN fleet).
// The backend provisions it on the `raven` provider: it mints a fresh vEdge Org
// + org_admin user and stores the per-customer credential, then the customer
// manages domains/analytics/backends from the orchestrator console. So an
// "Activate Multi-CDN" action targets the `raven` provider.

/** Provider codename that backs a first-time Multi-CDN activation (vEdge). */
export const CDN_PROVIDER = 'raven';

/** Route to a CDN orchestrator console (matches CdnHomePage BASE). */
export function cdnConsoleRoute(serviceId: string): string {
  return `/services/cdn/${serviceId}`;
}

/** Card metadata for the Multi-CDN product (activation dialog copy). */
export const CDN_PRODUCT = {
  displayName: 'Multi-CDN',
  description:
    'Multi-CDN Orchestration — deliver your domains across multiple CDN backends from one console, with unified analytics and failover.',
  features: ['Multi-backend delivery', 'Unified analytics', 'Origin failover', 'Edge caching'],
} as const;
